import React from 'react';
import { func, shape } from 'prop-types';

import { Container, Row, Col, Button } from '@ajaibid/components';

import { useValidateForm } from '../StockBuySell/hooks';
import { ORDER_DETAIL_SHAPE } from './adapter';

const StockAmendSubmitBtn = (props) => {
  const { orderDetail, onCancel, onSubmit } = props;

  const { isFormValidated } = useValidateForm({ orderDetail });

  const handleSubmit = () => {
    onSubmit();
  };

  return (
    <Container padding="12px 16px">
      <Row gutters={4}>
        <Col size={6}>
          <Button variant="naked" fluid size="lg" onClick={onCancel}>
            Kembali
          </Button>
        </Col>
        <Col size={6}>
          <Button
            variant="primary"
            fluid
            size="lg"
            disabled={!isFormValidated}
            onClick={handleSubmit}
          >
            Ubah
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

StockAmendSubmitBtn.propTypes = {
  orderDetail: shape(ORDER_DETAIL_SHAPE),
  onCancel: func,
  onSubmit: func,
};

StockAmendSubmitBtn.defaultProps = {
  orderDetail: {},
  onCancel: () => {},
  onSubmit: () => {},
};

export default StockAmendSubmitBtn;
